<svelte:options customElement="hb-layout" />

<script lang="ts">
  /**
   * Svelte Video Gallery WebComponent
   * =====================
   *
   * @contributors: Dario Caruso <dev@dariocaruso.info> (https://dariocaruso.info)
   *
   * @license: MIT License
   *
   */

  import pkg from "../../../package.json";

  import type { Component } from "./types/webcomponent.type";

  import type { Events as LayoutDesktopEvents } from "../layout-desktop/types/webcomponent.type";
  import type { Events as LayoutMobileEvents } from "../layout-mobile/types/webcomponent.type";
  import { addComponent } from "wc-js-utils";

  let {
    id = "",
    // style = "",
    heders = undefined,
    footer = undefined,
    cookielawuri4more = "",
    cookielawallowdecline = "",
    cookielawlanguage = "",
    pagename = undefined,
    cookielaw = undefined,
    single_screen = undefined,
    sidebar = undefined,
    socials = undefined,
    navlinks = undefined,
    contacts = undefined,
    columns = undefined,
    usermenu = undefined,
    i18nlang = undefined,
    i18nlanguages = undefined,
    page_title = undefined,
    policies = undefined,
    company = undefined,
  }: Component = $props();

  let navopen: boolean;
  let innerWidth: number = $state(0);

  function dispatch(name: string, detail: any) {
    $host().dispatchEvent(new CustomEvent(name, { detail }));
  }

  // const recheckSize = debounce(detectSize, 500);
  // onMount(() => {
  // 	detectSize();
  // 	window.addEventListener("resize", recheckSize);
  // 	return () => {
  // 		window.removeEventListener("resize", recheckSize);
  // 	};
  // });

  // function detectSize() {
  // 	console.log("checkSize");
  // 	if (!window?.innerWidth) {
  // 		if (wSize) return wSize;

  // 		return 0;
  // 	}

  // 	wSize = window.innerWidth;
  // 	// if (size) {
  // 	// 	layoutType = size;
  // 	// 	return;
  // 	// }
  // 	// if (wSize < 800) {
  // 	// 	layoutType = "small";
  // 	// } else {
  // 	// 	layoutType = "large";
  // 	// }
  // 	// dispatch("layoutStatus", { width: wSize, size: layoutType });

  // 	console.log("size:", wSize);
  // }

  addComponent({
    repoName: "@htmlbricks/hb-layout-desktop",
    version: pkg.version,
  });
  addComponent({
    repoName: "@htmlbricks/hb-layout-mobile",
    version: pkg.version,
  });
</script>

<svelte:head>
  {#if heders}
    {#each heders as header (header.content + "" + header.property + header.name)}
      {#if header.name}
        <meta name={header.name} content={header.content} />
      {:else if header.property}
        <meta property={header.property} content={header.content} />
      {/if}
    {/each}
  {/if}
</svelte:head>

<svelte:window bind:innerWidth />
{#if innerWidth < 800}
  <hb-layout-mobile
    id="layout_mobile"
    {page_title}
    {company}
    {sidebar}
    {pagename}
    {socials}
    {navlinks}
    {contacts}
    {i18nlang}
    {i18nlanguages}
    {columns}
    {single_screen}
    {usermenu}
    {cookielawlanguage}
    {cookielawallowdecline}
    {cookielawuri4more}
    {cookielaw}
    {footer}
    {policies}
    onlanguageChange={(l: { detail: LayoutMobileEvents["languageChange"] }) =>
      dispatch("languageChange", l.detail)}
    onfooterClick={(l: { detail: LayoutMobileEvents["footerClick"] }) =>
      dispatch("footerClick", l.detail)}
    onpageChange={(l: { detail: LayoutMobileEvents["pageChange"] }) =>
      dispatch("pageChange", l.detail)}
    onoffcanvasswitch={(l: { detail: LayoutMobileEvents["offcanvasswitch"] }) =>
      dispatch("offcanvasswitch", l.detail)}
    onnavbarSlotClick={(l: { detail: LayoutMobileEvents["navbarSlotClick"] }) =>
      dispatch("navbarSlotClick", l.detail)}
    onthemeChange={(l: { detail: LayoutMobileEvents["themeChange"] }) =>
      dispatch("themeChange", l.detail)}
  >
    <div slot="page">
      <slot name="page">page</slot>
    </div>
    <span slot="nav-header-slot"><slot name="nav-header-slot" /></span>

    <span slot="nav-left-slot"><slot name="nav-left-slot" /></span>
    <span slot="nav-center-slot"><slot name="nav-center-slot" /></span>
    <span slot="nav-right-slot"><slot name="nav-right-slot" /></span>
  </hb-layout-mobile>
{:else}
  <hb-layout-desktop
    id="layout_desktop"
    {page_title}
    {company}
    {sidebar}
    {pagename}
    {socials}
    {navlinks}
    {contacts}
    {i18nlang}
    {i18nlanguages}
    {columns}
    {single_screen}
    {usermenu}
    {cookielawlanguage}
    {cookielawallowdecline}
    {cookielawuri4more}
    {cookielaw}
    {footer}
    {policies}
    onlanguageChange={(l: { detail: LayoutDesktopEvents["languageChange"] }) =>
      dispatch("languageChange", l.detail)}
    onnavbarDropDownClick={(l: {
      detail: LayoutDesktopEvents["navbarDropDownClick"];
    }) => dispatch("navbarDropDownClick", l.detail)}
    onfooterClick={(l: { detail: LayoutDesktopEvents["footerClick"] }) =>
      dispatch("footerClick", l.detail)}
    onpageChange={(l: { detail: LayoutDesktopEvents["pageChange"] }) =>
      dispatch("pageChange", l.detail)}
    onoffcanvasswitch={(l: {
      detail: LayoutDesktopEvents["offcanvasswitch"];
    }) => dispatch("offcanvasswitch", l.detail)}
    onnavbarSlotClick={(l: {
      detail: LayoutDesktopEvents["navbarSlotClick"];
    }) => dispatch("navbarSlotClick", l.detail)}
    onthemeChange={(l: { detail: LayoutDesktopEvents["themeChange"] }) =>
      dispatch("themeChange", l.detail)}
  >
    <div slot="page">
      <slot name="page">page</slot>
    </div>
    <div slot="nav-center-slot"><slot name="nav-center-slot" /></div>
    <div slot="nav-right-slot"><slot name="nav-right-slot" /></div>
  </hb-layout-desktop>
{/if}

<style lang="scss">
  @forward "./styles/bulma.scss";
  @forward "./styles/webcomponent.scss";
</style>
